import { StyleSheet } from 'react-native';
import { colors, dimensions } from '../../../../styles';
import { isIos, isIphoneX } from '../../../../utils/detectDevice';
import {medium} from "../../../../styles/dimensions";

const styles = StyleSheet.create({
  buttonContainer: {
    width: '100%',
    height: 40,
    paddingHorizontal: dimensions.medium,
    marginTop: dimensions.halfMedium,
    marginBottom: isIphoneX ? dimensions.doubleMedium : dimensions.medium,
  },

  image: {
    width: 240,
    height: 130,
    alignSelf: 'center',
    marginTop: dimensions.doubleMedium,
    marginBottom: dimensions.doubleMedium,
  },

  inputContainer: {
    width: dimensions.width - dimensions.doubleMedium,
    backgroundColor: colors.grayLighter,
    paddingHorizontal: dimensions.medium,
    paddingVertical: isIos ? dimensions.halfMedium : 0,
    marginHorizontal: dimensions.medium,
    maxWidth: dimensions.mobileWidth,
  },

  input: {
    textAlign: 'left',
  },

  keyboardAvoidingView: {
    flex: 1,
    marginBottom: isIos ? dimensions.doubleMedium : 0,
  },

  infoText: {
    lineHeight: 22,
    marginBottom: 40,
    paddingHorizontal: dimensions.medium,
  },
});

export default styles;
